export default __webpack_public_path__ + "fonts/inter-latin-100-normal.f6662495a3dbd11d93eb.woff";